import {
  default as ValueLabel,
  ValueLabelProps,
} from 'components/Common/ValueLabel/ValueLabel'
import { useAppSelector } from 'store/configureStore'
import { RootAppState } from 'store/configureStore'

export const ValueLabelConnected = (props: {
  propertySelector: (state: RootAppState) => React.ReactText
  valueLabelProps?: Partial<ValueLabelProps>
}) => {
  const valueFromStore = useAppSelector(props.propertySelector)

  return <ValueLabel {...props.valueLabelProps} value={valueFromStore} />
}
